import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import configs from 'constants/configs';
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBar } from "./SearchBar";
import { TableDanhSach } from "./TableDanhSach";
import  danhSachThongTinVayApi  from "../../../service/ChoThongTin/danhSachThongTinVayApi";
import { updateSearch } from "../../../actions/ChoThongTin/DanhSachVay";
import userApi from "../../../service/userApi";
export const DanhSachDaMua = () => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.danhSachThongTinVay);
  useEffect(() => {
    danhSachThongTinVayApi.phanquyenDsDangKyVay().then((dataUser) => {
      if(typeof dataUser.data.chotindung_danhsachdangkyvay === "undefined" ||  dataUser.data.chotindung_danhsachdangkyvay == false){
        window.location.href = configs.errorLink;
      }else{
        userApi.getCurrentUser().then((dataUser) => {
          dispatch(
            updateSearch({
              ...dataSearch,
              IdCuaHang: dataUser.data.CompanyID,
            })
          );
        });
      }
    });
  }, []);

  return (
    <Layout>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Danh sách thông tin đã mua"
                      icon1="mdi mdi-warehouse"
                    />
                  </div>
                </div>
                {dataSearch.IdCuaHang != 0 && 
                (<SearchBar />)}
                <TableDanhSach/>
              </div>
            </div>
          </div>
          {/* <TableDanhSach/> */}
        </div>

    </Layout>
  );
};
